// extracted by mini-css-extract-plugin
export var modalFooter = "_qu-0";